import { lang } from '@/utils/filters'
// console(lang('请输入'))
import { bus } from '@utils/common'

const RULESJson = function () {
  return {
    required: { message: lang('请输入'), required: true, trigger: ['blur', 'change'] },
    requiredTrim: { required: true, pattern: '[^ \x22]+', message: lang('请输入'), trigger: ['blur', 'change'] },
    requiredSelect: { message: lang('请选择'), required: true, trigger: ['blur', 'change'] },
    lengthTwo: { min: 0, max: 2, message: lang('限2个字符内'), trigger: ['blur'] },
    fourty: { max: 40, message: lang('限40个字符内'), trigger: ['blur', 'change'] },
    twenty: { max: 20, message: lang('限20个字符内'), trigger: ['blur', 'change'] },
    senderName: { min: 1, max: 11, message: lang('姓名不正确'), trigger: ['blur', 'change'] }, // 寄件人姓名
    senderMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 寄件人手机号
    receiverName: { min: 2, max: 11, message: lang('姓名不正确'), trigger: ['blur', 'change'] },
    receiverMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 收件人手机号
    // goods: { message: '请输入物品类型', trigger: ['blur', 'change'] }, // 物品类型名称
    goodsName: { message: lang('请输入物品名称'), trigger: ['blur', 'change'] }, // 物品名称
    packageTotalWeight: { validator: integerWeight, trigger: ['blur', 'change'] }, // 物品重量
    packageNumber: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品件数
    // payment: { message: '请输入支付方式名称', trigger: ['blur', 'change'] }, // 支付方式名称
    declaredValue: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品价值
    checkPassword: { validator: checkPassword, trigger: ['blur', 'change'] }, // 验证密码
    updatePassword: { validator: updatePassword, trigger: ['blur', 'change'] }, // 验证更新密码
    tenNumStrChar: { validator: tenNumStr, trigger: ['blur', 'change'] }, // 验证密码
    checkPhone: { validator: checkPhone, trigger: ['blur', 'change'] },
    checkPhoneNew: { validator: checkPhoneNew, trigger: ['blur', 'change'] },
    phoneAndMobile: { validator: phoneAndMobile, trigger: ['blur', 'change'] },
    canNotHasChinase: { validator: canNotHasChinase, trigger: ['blur', 'change'] },
    phoneRule: { validator: phoneRule, trigger: ['blur', 'change'] },
    phoneAndMobileInter: { validator: phoneAndMobileInter, trigger: ['blur', 'change'] },
    email: { validator: email, trigger: ['blur', 'change'] }, // 邮箱
    productDescription: { required: true, min: 10, max: 1000, message: lang('请输入10到1000个字符'), trigger: ['blur', 'change'] },
    phoneUpdateMobile: { validator: phoneUpdateMobile, trigger: ['blur', 'change'] },
    phoneMobileModify: { validator: phoneMobileModify, trigger: ['blur', 'change'] },
    goodMoney: { validator: goodMoneyValidate, trigger: ['blur', 'change'] },
    codeNumber: { validator: codeNumber, trigger: ['blur', 'change'] },
  }
}
export const RULES = RULESJson()
bus.$on('langJsonChange', (data) => {
  const RULESJsonData = RULESJson()
  Object.keys(RULESJsonData).forEach(element => {
    RULES[element] = Object.assign({}, RULESJsonData[element])
  })
})
export const VALIDATION = {
  'num_chinese_en': {
    'value': /^([\u4e00-\u9fa5A-Za-z0-9]{1,12})$/i,
    'label': lang('中文字符/数字/英文，长度为1-12位'),
  },
  'canNotHasChinase': {
    'value': /[\u4E00-\u9FA5]/i,
    'label': lang('不能输入中文'),
  },
  // 'phoneNumber': {
  //   'value': /^1[3|4|5|7|8][0-9]\d{8,8}$/,
  //   'label': '输入的手机号码格式不正确',
  // },
  'phoneNumber': {
    // 'value': /^1\d{10}$/,
    'value': /\d$/, // 国际版去掉限制
    'label': lang('输入的手机号码格式不正确'),
  },
  'phoneAndMobileInter': {
    'value': /^[0-9\(\)\-\+\s]+$/i,
    'label': lang('数字或连接符- + () 组成'),
  },
  // 'phoneAndMobile': {
  //   'value': /^[0-9\(\)\-\+\s]+$/i,
  //   'label': lang('数字或连接符- + () 组成'),
  // },
  'phoneAndMobile': {
    'value': /^[5|4]\d{8}$/,
    'label': lang('只支持首位4或5的9位数字'),
  },
  'phoneAndMobileNew': {
    'value': /^([0-9\-\+\s]{8,16})$/i,
    'label': lang('数字,长度为8-16位'),
  },
  'phoneAndMobileNew1': {
    'value': /^[1-9]\d{7,8}$/,
    'label': lang('非0开头,长度为8-9位'),
  },
  'phoneMobileModify': {
    'value': /^[1-9]\d{7,8}$/,
    'label': lang('非0开头,长度为8-9位'),
  },
  'phoneAndMobile4': {
    'value': /^([0-9\-\+\s]{8,16})$/i,
    'label': lang('数字,长度为8-16位'),
  },
  'phoneAndMobile2': {
    'value': /^([0-9\-\+\s]{1,16})$/i,
    'label': lang('数字,长度为1-11位'),
  },
  'phoneAndMobile3': {
    'value': /^([0-9\-\+\s]{1,15})$/i,
    'label': lang('数字,长度为1-11位'),
  },
  'phoneAndMobile86': {
    'value': /^([0-9\-\+\s]{15})$/i,
    'label': lang('86电话只能输入11位号码'),
  },
  'phoneAndMobile966': {
    'value': /^([0-9\-\+\s]{14})$/i,
    'label': lang('966电话只能输入9位号码'),
  },
  'phoneAndMobile971': {
    'value': /^([0-9\-\+\s]{14})$/i,
    'label': lang('971电话只能输入9位号码'),
  },
  'address': {
    'value': /.*/i,
    'label': lang('输入的地址格式不正确'),
  },
  'float': {
    'value': /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/i,
    'label': lang('请输入大于0且保留两位小数点的数字'),
  },
  'integerNum': {
    'value': /^([1-9][0-9]*)$/i,
    'label': lang('请输入大于0的整数'),
  },
  'checkPassword': {
    'value': /^[A-Z][A-Za-z0-9]{5,17}$/,
    'label': lang('请输入大写字母开头的6-18位英文和数字'),
  },
  'updatePassword': {
    'value': /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
    // 'value': (?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$",
    'label': lang('密码长度为8-30位，至少包含大小写字母、数字、特殊字符中的三种'),
  },
  // 'ten_num_str': {
  //   'value': /^([@,\.#%'\+\*\-:;^_`()&$/A-Za-z0-9]{1,12})$/i,
  //   'label': '仅支持10个以内的字母、数字、部分符号',
  // },
  'ten_num_str': {
    'value': /^([A-Za-z0-9]{1,10})$/i,
    'label': lang('仅支持10个以内的字母、数字'),
  },
  'checkBlack': {
    'value': /\s+/,
    'label': '请输入',
  },
  code: {
    value: /^([a-zA-Z0-9]{1,100})$/, // /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{1,100}$/
    label: lang('英文和数字的组合')
  },
  email: {
    value: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
    label: lang('输入的邮箱格式不正确')
  },
  weightBlue: {
    value: /^\d{1,5}(\.\d{1,2})?$/,
    label: lang('请输入1-5位小数点后2位')
  },
  goodMoneyValidate: {
    value: /^\d{1,8}(\.\d{1,2})?$/,
    label: lang('请输入1-8位小数点后2位')
  },
  codeNumber: {
    value: /^[A-Za-z]{4}\d{4}$/,
    label: lang('不符合短地址规则'),
  }
}

// @desc 权限名称30个中文字符/数字/英文
export function num_chinese_en(rule, value, callback) {
  if (value && !VALIDATION.num_chinese_en.value.test(value)) {
    callback(new Error(lang(VALIDATION.num_chinese_en.label)))
  } else {
    callback()
  }
}

// 校验手机号不能超过11位，且为数字 TODO
export function checkPhone(rule, value, callback) {
  if (value && !VALIDATION.phoneNumber.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneNumber.label)))
  } else {
    callback()
  }
}
// 校验手机号不能超过11位，且为数字 TODO
export function checkPhoneNew(rule, value, callback) {
  if (value && !VALIDATION.phoneAndMobileNew.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobileNew.label)))
  } else {
    callback()
  }
}

// 手机电话区号校验
export function phoneRule(rule, value, callback) {
  console.log(value)
  if (value && value.split('-')[0] === '+86') {
    if (!VALIDATION.phoneAndMobile3.value.test(value)) {
      callback(new Error(lang(VALIDATION.phoneAndMobile3.label)))
    }
    if ((value.indexOf('+') !== -1 && value.split('+').length > 2) || (value.indexOf('-') !== -1 && value.split('-').length > 2)) {
      callback(new Error(lang(VALIDATION.phoneAndMobile3.label)))
    }
  } else if (value && value.split('-')[0] === '+966') {
    if (!VALIDATION.phoneAndMobile2.value.test(value)) {
      callback(new Error(lang(VALIDATION.phoneAndMobile2.label)))
    }
    if ((value.indexOf('+') !== -1 && value.split('+').length > 2) || (value.indexOf('-') !== -1 && value.split('-').length > 2)) {
      callback(new Error(lang(VALIDATION.phoneAndMobile2.label)))
    }
  } else {
    callback()
  }
}

// 手机号和座机号
export function phoneAndMobile(rule, value, callback) {
  // value = value && value.split('-')[1]
  console.log(value)
  if (value && (/\+86/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile86.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile86.label)))
  } else if (value && !VALIDATION.phoneAndMobileNew1.value.test(value.split('-')[1])) {
    callback(new Error(lang(VALIDATION.phoneAndMobileNew1.label)))
  } else {
    if (VALIDATION.checkBlack.value.test(value)) {
      callback(new Error(lang('请勿输入空格')))
    } else {
      callback()
    }
  }
  // if (value && !VALIDATION.phoneAndMobileNew.value.test(value)) {
  //   callback(new Error(lang(VALIDATION.phoneAndMobileNew.label)))
  // } else if (value && (/\+86/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile86.value.test(value)) {
  //   callback(new Error(lang(VALIDATION.phoneAndMobile86.label)))
  // } else if (value && (/\+971/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile971.value.test(value)) {
  //   callback(new Error(lang(VALIDATION.phoneAndMobile971.label)))
  // } else if (value && (/\+966/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile966.value.test(value)) {
  //   callback(new Error(lang(VALIDATION.phoneAndMobile966.label)))
  // } else {
  //   if (VALIDATION.checkBlack.value.test(value)) {
  //     callback(new Error(lang('请勿输入空格')))
  //   } else {
  //     callback()
  //   }
  // }
}

// 手机号和座机号国际件
export function phoneAndMobileInter(rule, value, callback) {
  console.log(value, /\+86/.test(value))
  if (value && !VALIDATION.phoneAndMobileInter.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobileInter.label)))
  } else if (value && (/\+86/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile86.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile86.label)))
  } else if (value && (/\+971/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile971.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile971.label)))
  } else if (value && (/\+966/.test(value)) && value.length > 4 && !VALIDATION.phoneAndMobile966.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile966.label)))
  } else {
    if (VALIDATION.checkBlack.value.test(value)) {
      callback(new Error(lang('请勿输入空格')))
    } else {
      callback()
    }
  }
}
// 校验输入的地址格式是否正确
export function checkAddressFormat(rule, value, callback) {
  if (value.length < 1 || value.length > 200) {
    callback(new Error(lang('详细地址只能在1-200字符之间')))
  } else {
    if (value && !VALIDATION.address.value.test(value)) {
      callback(new Error(lang(VALIDATION.address.label)))
    } else {
      callback()
    }
  }
}

// 非0开头的8到9位数
export function phoneMobileModify(rule, value, callback) {
  if (value && !(VALIDATION.phoneMobileModify.value.test(value))) {
    callback(new Error(lang(VALIDATION.phoneMobileModify.label)))
  } else {
    callback()
  }
}

// 校验输入的地址格式是否正确
export function phoneUpdateMobile(rule, value, callback) {
  if (value && !(VALIDATION.phoneAndMobile4.value.test(value))) {
    callback(new Error(lang(VALIDATION.phoneAndMobile4.label)))
  } else {
    callback()
  }
}

//  小数
export function integerWeight(rule, value, callback) {
  if (!value && !VALIDATION.float.value.test(value)) {
    callback(new Error(lang(VALIDATION.float.label)))
  } else {
    callback()
  }
}

//  纯数字
export function integerNum(rule, value, callback) {
  if (value && !VALIDATION.integerNum.value.test(value)) {
    callback(new Error(lang(VALIDATION.integerNum.label)))
  } else {
    callback()
  }
}

// 验证密码
export function checkPassword(rule, value, callback) {
  if (value && !(VALIDATION.checkPassword.value.test(value) && (/\d/).test(value))) {
    callback(new Error(lang(VALIDATION.checkPassword.label)))
  } else {
    callback()
  }
}

// 更新密码验证
export function updatePassword(rule, value, callback) {
  if (value && !(VALIDATION.updatePassword.value.test(value) && (/\d/).test(value))) {
    callback(new Error(lang(VALIDATION.updatePassword.label)))
  } else {
    callback()
  }
}

// 物品名称
export function checkGoodsName(rule, value, callback) {
  if (value.length > 100) {
    callback(new Error(lang('物品名称长度不能大于100个字符')))
  } else {
    callback()
  }
}

export function tenNumStr(rule, value, callback) {
  if (value && !VALIDATION.ten_num_str.value.test(value)) {
    callback(new Error(lang(VALIDATION.ten_num_str.label)))
  } else {
    callback()
  }
}

// 是否为{}空对象
export function isNullObj(rule, value, callback) {
  if (JSON.stringify(value) === '{}') {
    callback(new Error('请选择'))
  } else {
    callback()
  }
}

// 是否为空格
export function isNull(rule, value, callback) {
  // if (VALIDATION.checkBlack.value.test(value)) {
  //   callback(new Error(lang('请勿输入空格')))
  // } else {
  //   callback()
  // }
  if (value.length > 50) {
    callback(new Error(lang('姓名长度不能大于30个字符')))
  } else {
    callback()
  }
}

// 不能有中文
export function canNotHasChinase(rule, value, callback) {
  if (VALIDATION.canNotHasChinase.value.test(value)) {
    callback(new Error(lang('不能输入中文')))
  } else {
    callback()
  }
}

// email邮箱格式校验
export function email(rule, value, callback) {
  if (!VALIDATION.email.value.test(value)) {
    callback(new Error(VALIDATION.email.label))
  } else {
    callback()
  }
}

export function goodMoneyValidate(rule, value, callback) {
  if (!VALIDATION.goodMoneyValidate.value.test(value)) {
    callback(new Error(VALIDATION.goodMoneyValidate.label))
  } else {
    callback()
  }
}

export function codeNumber(rule, value, callback) {
  if (value && !VALIDATION.codeNumber.value.test(value)) {
    callback(new Error(VALIDATION.codeNumber.label))
  } else {
    callback()
  }
}
